/**
 *
 * @component   施工进度/ 查看进度验收说明弹窗
 *
 **/

import { memo } from 'react';
import { Form, Space, Button, Image, Spin } from 'antd';
import BaseModal from '&/components/BaseModal';
import CheckStatus from './CheckStatus';
import {
    queryPlanAudit,
    queryFinishDetail,
} from '@/api/personCenter/projectSpace1.4';
import moment from 'moment';
import PreviewVideo from '&/components/PreviewVideo';
import PreviewAudio from '&/components/PreviewAudio';
import './CheckProgress.scss';

function CheckProgress(props) {
    const { visible = true, onCancel, params } = props;
    const [isOverview, setIsOverview] = useState(true);
    const [result, setResult] = useState({});

    useEffect(() => {
        visible ? queryAudit() : setResult({});
    }, [visible]);

    const [isLoading, setIsLoading] = useState(false);

    function queryAudit() {
        setIsOverview(true);
        setIsLoading(true);
        queryPlanAudit(params)
            .then(({ data }) => {
                setResult(data);
            })
            .finally(setIsLoading.bind(null, false));
    }

    const [finishData, setFinishData] = useState({
        planDetail: {},
        planFinish: {},
        planFinishAdjuncts: [],
    });

    const viewDetail = () => {
        setIsLoading(true);
        queryFinishDetail(params)
            .then(({ data }) => {
                setFinishData(data);
                setIsOverview(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    //   渲染动态列表里的  附件
    const calcAccessory = (arr = []) => {
        const LIST = arr;
        if (!LIST.length) return undefined;
        function baseCb(type) {
            return el => el.fileType === type;
        }
        return (
            <>
                {LIST.some(baseCb('1')) && (
                    <div className="media-content-image">
                        <Image.PreviewGroup>
                            {LIST.filter(baseCb('1')).map(el => (
                                <Image key={el.id} src={el.thumbUrl}></Image>
                            ))}
                        </Image.PreviewGroup>
                    </div>
                )}

                {LIST.some(baseCb('2')) &&
                    LIST.filter(baseCb('2')).map(el => (
                        <div
                            key={el.id}
                            className="media-content-video"
                            onClick={() => previewVideo(el.originalUrl)}>
                            <Image
                                preview={false}
                                src={el.thumbUrl}
                                fallback={
                                    require('@/assets/img/userCenter1.4/xqdefault.png')
                                        .default
                                }
                            />
                            <i className="filled icon-play-circle2 play-btn"></i>
                        </div>
                    ))}

                {LIST.some(baseCb('3')) &&
                    LIST.filter(baseCb('3')).map(el => (
                        <div className="media-content-file" key={el.id}>
                            <section
                                className="file-item text-no-wrap"
                                onClick={() => previewPDF(el.url)}
                                title={el.describe}>
                                <i className="filled icon-Docment-PDF file-icon"></i>
                                {el.describe}
                            </section>
                        </div>
                    ))}

                {LIST.some(baseCb('4')) &&
                    LIST.filter(baseCb('4')).map(el => (
                        <div className="media-content-file" key={el.id}>
                            <section
                                className="file-item text-no-wrap"
                                onClick={() => previewAudioVideo()}
                                title={el.describe}>
                                <i className="filled icon-Document-Music file-icon"></i>
                                {el.describe}
                            </section>
                        </div>
                    ))}
            </>
        );
    };

    const overview = (
        <Spin spinning={isLoading}>
            {result.status && <CheckStatus isPass={result.status === '1'} />}
            <section className="form-group">
                <Form labelCol={{ span: 5 }} labelAlign="left">
                    <Form.Item label={intl.get('userCenter.accepter')}>
                        {result.checkName}
                    </Form.Item>
                    <Form.Item label={intl.get('userCenter.acceptanceTime')}>
                        {result.checkDate}
                    </Form.Item>
                    {result.status === '0' && (
                        <>
                            <Form.Item
                                label={intl.get(
                                    'userCenter.acceptanceExplain'
                                )}>
                                <div className="show-space">
                                    {result.remark}
                                </div>
                            </Form.Item>
                            {!!result.adjunctData?.length && (
                                <Form.Item
                                    label={intl.get(
                                        'templateSettings.acceptanceExplain'
                                    )}>
                                    {calcAccessory(result.adjunctData)}
                                </Form.Item>
                            )}
                        </>
                    )}

                    <Form.Item label={intl.get('userCenter.acceptanceDetail')}>
                        <a className="native-link" onClick={viewDetail}>
                            {intl.get('userCenter.clickForViwe')}
                        </a>
                    </Form.Item>
                </Form>
            </section>
        </Spin>
    );

    const mediaSrc = useRef({
        video: '',
        audio: '',
    });
    const [videoVisible, setVideoVisible] = useState(false);
    const closeVideoHandler = () => {
        setVideoVisible(false);
    };

    const previewVideo = src => {
        mediaSrc.current.video = src;
        setVideoVisible(true);
    };

    const [audioVisible, setaudioVisible] = useState(false);
    const previewAudioVideo = src => {
        mediaSrc.current.audio = src;
        setaudioVisible(true);
    };

    // const history = useHistory();
    const previewPDF = src => {
        // 协议统一
        const path = src.replace(/^https?:/i, window.location.protocol);
        window.open(window.location.origin + `/preview-pdf?path=${path}`);
    };

    const progressDetail = (
        <>
            <Form labelCol={{ span: 5 }}>
                <section className="form-group">
                    <Form.Item label={intl.get('projectSpace.plan')}>
                        {finishData.planDetail.name}
                    </Form.Item>
                    <Form.Item label={intl.get('projectSpace.planLimit')}>
                        {moment(finishData.planDetail.timeAt).format(
                            'YYYY-MM-DD'
                        )}
                        {intl.get('base.to')}
                        {moment(finishData.planDetail.timeEnd).format(
                            'YYYY-MM-DD'
                        )}
                    </Form.Item>
                </section>
                <section className="form-group">
                    <Form.Item label={intl.get('projectSpace.completer')}>
                        {finishData.planFinish.finishName}
                    </Form.Item>
                    <Form.Item label={intl.get('projectSpace.completeTime')}>
                        {finishData.planFinish.finishDate}
                    </Form.Item>
                    <Form.Item label={intl.get('projectSpace.completeRemark')}>
                        <div className="show-space">
                            {finishData.planFinish.remark}
                        </div>
                    </Form.Item>
                    {!!finishData.planFinishAdjuncts?.length && (
                        <Form.Item
                            label={intl.get('templateSettings.accessory')}>
                            {calcAccessory(finishData.planFinishAdjuncts)}
                        </Form.Item>
                    )}
                </section>
            </Form>
        </>
    );

    return (
        <BaseModal
            width="25.75rem"
            visible={visible}
            title={intl.get('projectSpace.processExplain')}
            wrapClassName="check-progress"
            footer={
                <Space>
                    <Button onClick={onCancel}>{intl.get('base.close')}</Button>
                </Space>
            }
            onCancel={onCancel}>
            {isOverview ? overview : progressDetail}

            <PreviewVideo
                visible={videoVisible}
                src={mediaSrc.current.video}
                onCancel={closeVideoHandler}
            />

            <PreviewAudio
                visible={audioVisible}
                src={mediaSrc.current.audio}
                onCancel={() => setaudioVisible(false)}
            />
        </BaseModal>
    );
}

export default memo(CheckProgress);
